import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TopbarComponent } from '../topbar/topbar.component';
import { FooterComponent } from '../footer/footer.component';
import { MenuService } from '../../core/services/menu.service';
import { IdleTimeoutService } from '../../core/services/idle-timeout.service';
import { IdleTimeoutDialogComponent } from '../../shared/components/idle-timeout-dialog/idle-timeout-dialog.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    SidebarComponent,
    TopbarComponent,
    FooterComponent,
    IdleTimeoutDialogComponent
  ],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.css'
})
export class AppLayoutComponent implements OnInit, OnDestroy {
  private readonly menuService = inject(MenuService);
  private readonly idleTimeoutService = inject(IdleTimeoutService);

  isSidebarCollapsed = false;
  mobileOpen = false;

  ngOnInit(): void {
    // Load menus dynamically on app layout load (handles direct page refreshes)
    this.menuService.loadUserMenus().subscribe();
    // Start idle activity monitoring for authenticated user session
    this.idleTimeoutService.startMonitoring();
  }

  ngOnDestroy(): void {
    // Clean up timers and activity listeners when layout destroys
    this.idleTimeoutService.stopMonitoring();
  }

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  toggleMobile(): void {
    this.mobileOpen = !this.mobileOpen;
  }

  closeMobile(): void {
    this.mobileOpen = false;
  }
}
